import React from 'react';
import styles from '../../styles/contacts/ContactsWorkspace.module.css';
import { CloseIcon, DownloadIcon, FlagIcon, TrashIcon } from './ContactsIcons';

/**
 * Floating bar for multi-select. Appears only while rows are checked and
 * reports the count to assistive tech as it changes.
 */
export default function SelectionBar({ count, allFlagged, busy, onFlag, onExport, onDelete, onClear }) {
  if (count === 0) return null;

  return (
    <div className={styles.selectionBar} role="region" aria-label="Bulk actions">
      <span className={styles.selectionCount} aria-live="polite">
        {count} selected
      </span>
      <span className={styles.selectionDivider} aria-hidden="true" />
      <button
        type="button"
        className={`${styles.btn} ${styles.btnGhost} ${styles.btnSmall}`}
        onClick={onFlag}
        disabled={busy}
      >
        <FlagIcon size={15} filled={!allFlagged} />
        {allFlagged ? 'Unflag' : 'Flag'}
      </button>
      <button
        type="button"
        className={`${styles.btn} ${styles.btnGhost} ${styles.btnSmall}`}
        onClick={onExport}
        disabled={busy}
      >
        <DownloadIcon size={15} />
        Export
      </button>
      <button
        type="button"
        className={`${styles.btn} ${styles.btnDanger} ${styles.btnSmall}`}
        onClick={onDelete}
        disabled={busy}
      >
        <TrashIcon size={15} />
        Remove
      </button>
      <span className={styles.selectionDivider} aria-hidden="true" />
      <button type="button" className={styles.iconBtn} onClick={onClear} aria-label="Clear selection">
        <CloseIcon size={16} />
      </button>
    </div>
  );
}
